module.exports = __webpack_public_path__ + "static/media/archive-icon.ec943021.svg";